import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    toggleImg: false
  },
  mutations: {
    updateToggleImg (state, num) {
      state.toggleImg = num
    }
  },
  actions: {
  },
  modules: {
  }
})
